/// <amd-module name="Feed/Legacy/Protocols/NuGet/NuGetClientTool" />
import * as React from "react";

import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import {
    INuGetConnectToFeedPanelProps,
    NuGetConnectToFeedPanel
} from "Feed/Legacy/Protocols/NuGet/NuGetConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";
import { FeedView } from "Feed/Common/Contracts/Feed";
import { IVssPageContext } from "VSS/Platform/Context";

export class NuGetClientTool implements IPackageProtocolClient {
    public readonly name = "NuGet";

    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return React.createElement(NuGetConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            feedViews,
            hubAction
        } as INuGetConnectToFeedPanelProps);
    }
}
